import { Metadata } from 'next'

const title = 'Contact Us | Ship&Play'
const description =
  'Travel easier with support that’s always within reach—text or call our ' +
  'support team any day of the week.'
const url = 'https://www.shipplay.com/contact'
const image = 'https://media.shipplay.com/ship-sticks-og-image.png'

const metadata: Metadata = {
  title,
  description,
  alternates: {
    canonical: url,
  },
  openGraph: {
    type: 'website',
    url,
    siteName: 'Ship&Play',
    title,
    description,
    images: [
      {
        url: image,
        width: 1200,
        height: 630,
        alt: 'Contact Ship&Play — support every day of the week',
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title,
    description,
    images: [image],
  },
}

export default metadata
